import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import { Typography, Grid, Card, Button } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import moment from "moment/min/moment-with-locales";
import { colors } from "../components/Theme/WebTheme";
import { useNavigate } from "react-router-dom";
import { MAIN_COLOR, SECONDORY_COLOR } from "../common/sharedFunctions";
import { api } from "common";

const UserWalletDetails = (props) => {
    const { data } = props;
    const { t, i18n } = useTranslation();
    const { fetchUserWalletHistory } = api;
    const isRTL = i18n.dir();
    const settingsdata = useSelector((state) => state.settingsdata);
    const [selectedRow, setSelectedRow] = useState(null);
    const [settings, setSettings] = useState({});
    const navigate = useNavigate();
    const walletHistory = useSelector((state) => state.auth.walletHistory);
    const dispatch = useDispatch();

    useEffect(() => {
        if (settingsdata.settings) {
            setSettings(settingsdata.settings);
        }
    }, [settingsdata.settings]);

    useEffect(() => {
        dispatch(fetchUserWalletHistory(data?.id));
    }, [data, dispatch, fetchUserWalletHistory,]);

    const columns = [
        {
            title: t("requestDate"),
            field: "date",
            render: (rowData) =>
                rowData.date ? moment(rowData.date).format("lll") : null,
        },
        {
            title: t("amount"),
            field: "amount",
            editable: "never",
            render: (rowData) =>
                rowData.amount
                    ? settings.swipe_symbol
                        ? rowData.amount + " " + settings.symbol
                        : settings.symbol + " " + rowData.amount
                    : settings.swipe_symbol
                        ? "0 " + settings.symbol
                        : settings.symbol + " 0",
        },
        {
            title: t("transaction_id"),
            field: "transaction_id",
            render: (rowData) =>
                rowData.transaction_id ? rowData.transaction_id : rowData.txRef,
        },
        {
            title: t("type"),
            field: "type",
            render: (rowData) => {
                const typeColors = {
                    Debit: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
                    Credit: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                };
                const bg = typeColors[rowData.type] || "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)";
                return (
                    <div
                        style={{
                            background: bg,
                            color: "white",
                            padding: "6px 12px",
                            borderRadius: "20px",
                            fontWeight: "600",
                            width: "120px",
                            margin: "auto",
                            textAlign: "center",
                            fontSize: "12px",
                            boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                        }}
                    >
                        {t(rowData.type)}
                    </div>
                )
            },
        },
    ];

    return (

        <Card
            style={{
                borderRadius: "12px",
                backgroundColor: "#fff",
                marginTop: 20,
                marginBottom: 20,
                boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
                border: "none",
                padding: "20px"
            }}
        >
            <Grid
                container
                spacing={1}
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    direction: isRTL === "rtl" ? "rtl" : "ltr",
                }}
            >
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: 10,
                        marginBottom: 10,
                    }}
                >
                    <Card
                        style={{
                            borderRadius: "12px",
                            backgroundColor: colors.WHITE,
                            minHeight: 70,
                            minWidth: 300,
                            width: "80%",
                            color: "white",
                            display: "flex",
                            boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
                            border: "none",
                        }}
                    >
                        <Typography
                            style={{
                                fontSize: 20,
                                background: 'linear-gradient(135deg, #487FFF 0%, #3598db 100%)',
                                width: "100%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                fontWeight: "bold",
                            }}
                        >
                            {t("wallet_ballance")}
                        </Typography>
                        <Typography
                            style={{
                                fontSize: 30,
                                fontWeight: "bold",
                                color: colors.BLACK,
                                width: "100%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            {data?.walletBalance
                                ? settings.swipe_symbol
                                    ? data.walletBalance + " " + settings.symbol
                                    : settings.symbol + " " + data.walletBalance
                                : settings.swipe_symbol
                                    ? "0 " + settings.symbol
                                    : settings.symbol + " 0"}
                        </Typography>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <div
                        style={{
                            backgroundColor: colors.WHITE,
                            borderRadius: "12px",
                            boxShadow: "none",
                        }}
                    >
                        <div
                            dir={isRTL === "rtl" ? "rtl" : "ltr"}
                        >
                            <Button
                                variant="text"
                                onClick={() => {
                                    navigate(`/users/${props.id}`);
                                }}
                            >
                                <Typography
                                    style={{
                                        textAlign: isRTL === "rtl" ? "right" : "left",
                                        fontWeight: "bold",
                                        color: MAIN_COLOR,
                                    }}
                                >
                                    {`<<- ${t("go_back")}`}
                                </Typography>
                            </Button>
                        </div>
                        <MaterialTable
                            title={t("transaction_history_title")}
                            columns={columns}
                            style={{
                                direction: isRTL === "rtl" ? "rtl" : "ltr",
                                borderRadius: "12px",
                                boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
                                border: "none",
                                padding: "20px"
                            }}
                            data={walletHistory ? walletHistory : []}
                            onRowClick={(evt, selectedRow) =>
                                setSelectedRow(selectedRow.tableData.id)
                            }
                            options={{
                                pageSize: 10,
                                pageSizeOptions: [10, 15, 20],
                                exportButton: true,
                                rowStyle: (rowData) => ({
                                    backgroundColor:
                                        selectedRow === rowData.tableData.id ? "#f3f4f6" : "#FFF",
                                    borderBottom: "1px solid #f3f4f6",
                                    fontSize: "14px",
                                    color: "#374151"
                                }),
                                editable: {
                                    backgroundColor: colors.CARD_DETAIL,
                                    fontSize: "0.8em",
                                    fontWeight: "bold ",
                                    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                                },
                                headerStyle: {
                                    background: 'linear-gradient(135deg, #487FFF 0%, #3598db 100%)',
                                    color: '#fff',
                                    textAlign: "center",
                                    fontWeight: "600",
                                    fontFamily: 'Inter, sans-serif',
                                    border: "none",
                                    height: "50px",
                                },
                                cellStyle: {
                                    borderBottom: "1px solid #f3f4f6",
                                    textAlign: "center",
                                    padding: "12px",
                                },
                            }}
                            localization={{
                                toolbar: {
                                    searchPlaceholder: t("search"),
                                    exportTitle: t("export"),
                                },
                                pagination: {
                                    labelDisplayedRows: "{from}-{to} " + t("of") + " {count}",
                                    firstTooltip: t("first_page_tooltip"),
                                    previousTooltip: t("previous_page_tooltip"),
                                    nextTooltip: t("next_page_tooltip"),
                                    lastTooltip: t("last_page_tooltip"),
                                },
                            }}
                        />
                    </div>
                </Grid>
            </Grid>
        </Card>

    );
}

export default UserWalletDetails;
